import script from "./AccessibilityStatement.vue?vue&type=script&setup=true&lang=js"
export * from "./AccessibilityStatement.vue?vue&type=script&setup=true&lang=js"

import "./AccessibilityStatement.vue?vue&type=style&index=0&id=04898290&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-04898290"]])

export default __exports__